import { jsxs as t, jsx as a } from "react/jsx-runtime";
import { c as l } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import './Spinner.css';const e = "_small_5akon_1", o = "_medium_5akon_5", m = "_large_5akon_9", _ = "_spinner_5akon_13", v = "_light_5akon_86", c = "_dark_5akon_89", i = {
  small: e,
  medium: o,
  large: m,
  spinner: _,
  light: v,
  dark: c
}, g = l(i.spinner, {
  variants: {
    size: {
      s: i.small,
      m: i.medium,
      l: i.large
    },
    variant: {
      light: i.light,
      dark: i.dark
    }
  },
  defaultVariants: {
    size: "m",
    variant: "light"
  }
}), u = ({ className: n, size: s, variant: r }) => /* @__PURE__ */ t(
  "div",
  {
    "aria-label": "loading",
    className: d(g({ size: s, variant: r }), n),
    "data-cxy-name": "spinner",
    role: "status",
    children: [
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {}),
      /* @__PURE__ */ a("div", {})
    ]
  }
);
export {
  u as S
};
